<template>
  <el-dialog
    :append-to-body="true"
    title="创建场景联动规则"
    center
    :visible.sync="localDialogTableVisible"
     :close-on-click-modal="false"
    :before-close="close">
    <el-form
      ref="createForm"
      :rules="rules"
      :model="form">
      <el-form-item
        label="规则名称"
        prop="ruleName"
        :label-width="formLabelWidth">
        <el-input
          v-model.trim="form.ruleName"
          placeholder="请输入规则名称"
          autocomplete="off">
        </el-input>
      </el-form-item>
      <el-form-item
        label="规则描述"
        prop="ruleDescription"
        :label-width="formLabelWidth">
        <el-input
          type="textarea"
          v-model="form.ruleDescription"
          :rows="3"
          placeholder="请输入规则描述">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click='close'>取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createrules } from '@/api/ruleEngine.js'
export default {
  name: 'creatRule',
  data () {
    return {
      localDialogTableVisible: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        ruleName: '',
        ruleDescription: ''
      },
      rules: {
        ruleName: [
          {
            required: true,
            message: '请输入规则名称',
            trigger: 'blur'
          },
          {
            max: 30,
            message: '规则名称长度需小于 30 个字符',
            trigger: 'blur'
          }
        ],
        ruleDescription: [
          {
            max: 30,
            message: '规则描述长度需小于 30 个字符',
            trigger: 'blur'
          }
        ]
      },
      formLabelWidth: '90px'
    }
  },
  props: {
    creatDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    creatDialogVisible: {
      handler (value) {
        this.localDialogTableVisible = value
      },
      immediate: true
    }
  },
  methods: {
    confirm () {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          createrules(this.form).then(res => {
            console.log('创建成功', res)
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('refresh')
            this.close()
          }).catch(err => {
            console.log('err===', err)
            this.$message.error('创建失败')
          })
        } else {
          this.$message.error('验证失败')
          return false
        }
      })
    },
    close () {
      this.$refs.createForm.resetFields()
      this.$emit('update:creatDialogVisible', false)
    }
  }
}
</script>

<style scoped>

</style>
